import { useId } from 'react';
import './TasteOfJamaicaSection.css';

export default function TasteOfJamaicaSection({
  exploreHref = '/stay/st-mary#local-attractions',
}) {
  const titleId = useId();

  return (
    <section className="taste-of-jamaica" aria-labelledby={titleId}>
      <div className="taste-of-jamaica__card">
        <div className="taste-of-jamaica__intro">
          <p className="taste-of-jamaica__eyebrow">A TASTE OF JAMAICA</p>
          <h2 className="taste-of-jamaica__title" id={titleId}>
            Chase waterfalls.<br />
            Find your own rhythm.
          </h2>
        </div>
        <div className="taste-of-jamaica__content">
          <p className="taste-of-jamaica__description">
            Discover beaches, gardens and waterfall adventures{' '}
            around St Mary, from Pagee Beach to Blue Hole.<br className="taste-of-jamaica__desktop-break" />{' '}
            Let the day unfold at your own pace.
          </p>
          <a className="taste-of-jamaica__link" href={exploreHref}>
            Explore St Mary
          </a>
        </div>
      </div>
    </section>
  );
}
